import { useContext } from 'react';
import { IExportPlugin, PluginType } from '@/version-types';
import { InstanceData, InstanceDataType } from '../data';
import { StoreContext } from './context';
import { Core } from './instance';
import editorState from './states/editor-state';
import identityState from './states/identity-state';
import loadingState from './states/loading-state';

export * from './hooks';
export * from './utils';
export * from './context';
export * from './extensions/font-server';
export * from './libs/event-emitter';
export { getBehavior } from './behavior';

/** 通过 hook 获取 state */
export function useState<T>() {
    const stores = useContext(StoreContext);
    if (!stores) throw new Error('Missing StoreProvider');
    return stores as T;
}

/** 通过 api 获取 state */
export function getState<T>(identity: string) {
    return InstanceData.getData(identity, InstanceDataType.State) as T;
}

export const frameworkCorePlugin: IExportPlugin = {
    sort: 0,
    type: PluginType.EXTENSION,
    name: 'framework-core',
    createState() {
        return [editorState, identityState, loadingState];
    },
};

/** 创建核心对象 */
export function createCore(identity: string) {
    const core = new Core(identity);
    InstanceData.setData(identity, InstanceDataType.Core, core);
    return core;
}

/** 获取 core api */
export function CoreAPI(identity: string) {
    return InstanceData.getData(identity, InstanceDataType.Core) as Core;
}

export type ICore = ReturnType<typeof CoreAPI>;
